"use client";

import { motion } from "framer-motion";
import { useEffect } from "react";

const Refund = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-20"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-white p-8 shadow-lg md:p-12">
          <h1 className="mb-8 text-center text-4xl font-bold text-gray-900">
            Cancellation & Refund Policy
          </h1>

          <div className="prose prose-lg max-w-none leading-relaxed text-gray-700">
            <p className="mb-6 text-lg">
              At Nautilus Times, all transactions, once consummated through our
              digital interfaces, are construed as final, conclusive, and
              non-revocable. The maritime and allied service domains within
              which we operate necessitate financial flows, commitments, and
              allocations that cannot be unwound or retroactively altered.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              1. Non-Reversibility of Monetary Consideration
            </h2>
            <p className="mb-6">
              Upon successful remittance, whether via digital instruments,
              payment gateways, or any authorized channel, the funds transferred
              shall be deemed irrevocably appropriated toward the services,
              subscriptions, or informational products of Nautilus Times. For
              the avoidance of doubt, no reimbursement, restitution, or
              financial redress shall be effectuated under any classification,
              terminology, or interpretation.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              2. Waiver of Consumer Rescission
            </h2>
            <p className="mb-6">
              Clients, subscribers, or users hereby acknowledge that by engaging
              in contractual exchange with Nautilus Times, they explicitly waive
              any entitlement to rescind, retract, or revoke payment obligations
              under statutory, customary, or equitable doctrines, unless
              specifically mandated by overriding maritime law or regulatory
              compulsion.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              3. Service Continuity and Substitution
            </h2>
            <p className="mb-6">
              In exceptional circumstances where a specific digital service,
              subscription, or deliverable is rendered technically infeasible,
              Nautilus Times reserves the exclusive discretion to provide an
              alternative form of access, substitution, or deferred service
              delivery. Such substitution shall not, under any interpretation,
              be construed as grounds for refund eligibility.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              4. Technical Attribution
            </h2>
            <p className="mb-6">
              Any malfunction, latency, disruption, or discontinuity in access
              attributable to end-user hardware, network latency, connectivity
              failure, or third-party service providers shall not qualify as
              grounds for refund or financial restitution.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              5. Jurisdictional Limitation
            </h2>
            <p className="mb-6">
              This policy operates under the presumption of maritime commerce
              standards and is anchored in contractual finality. Users agree
              that non-refundability is a binding condition precedent to their
              engagement with Nautilus Times.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Refund;
